import fetch from "@lib/fetch";
import { API } from "../../config";

export const getAdminInfo = (token) => {
  return fetch(`${API}/v1/admin/info`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  });
};

export const updateAdminInfo = (token, data) => {
  return fetch(`${API}/v1/admin/info`,{
    mode: 'cors',
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  });
};
